export default __webpack_public_path__ + "static/media/barra3.015fcb04.png";